import { FovPageType } from '@contentsquare/fov-constants';
export const eventStreamClickCondition = {
    id: 'event-stream-click-condition',
    category: 'behaviors',
    value: {
        pageTypes: [
            {
                value: FovPageType.ANY,
                label: 'CONDITION_SELECT_ANY_PAGE',
            },
            {
                value: FovPageType.PAGE,
                label: 'CONDITION_SELECT_SPECIFIC_PAGE',
            },
            {
                value: FovPageType.URL,
                label: 'CONDITION_SELECT_SPECIFIC_URL',
            },
        ],
    },
};
//# sourceMappingURL=event-stream-click-condition.value.js.map